import React, { Component } from 'react'
import ParseEntry from './data'
import AdvisoryActivitiesContent from './component'

export default class AdvisoryActivitiesContentContainer extends Component {
  mapper = entry => {
    if (entry) {
      const { details, id, instructions, overview } = ParseEntry(entry)
      entry = {
        breadcrumb: entry.breadcrumb,
        details,
        id,
        instructions,
        overview,
      }

      return entry
    }

    return null
  }

  render() {
    const { routeContent } = this.props || {}
    const { content } = routeContent || {}
    const { advisoryActivity } = content || {}
    const parsedContent = this.mapper(advisoryActivity) || {}
    return <AdvisoryActivitiesContent {...parsedContent} />
  }
}
